import { Card } from "@/components/common";

export const ItemsTable = ({ rows, compare }) => (
  <Card title="Dishes in negative feedback" subtitle="Dishes that appear in at least 2 negative reviews. Negative % = share of that dish's reviewed orders that were negative." testid="items-table-card">
    {!rows.length ? <p className="py-10 text-center text-sm text-slate-400">No dish shows up repeatedly in negative feedback for this period.</p> : (
      <div className="-mx-2 overflow-x-auto">
        <table className="w-full min-w-[600px] text-sm">
          <thead><tr className="border-b text-left text-xs uppercase tracking-wider text-slate-400">
            <th className="px-2 py-2">Dish</th><th className="px-2 text-right">Negative reviews</th><th className="px-2 text-right">Reviewed orders</th>
            <th className="px-2 text-right">Negative %</th><th className="px-2">Main issue</th>{compare && <th className="px-2 text-right">Previous period</th>}
          </tr></thead>
          <tbody>
            {rows.map((i) => (
              <tr key={i.item} className="border-b border-slate-100" data-testid={`item-row-${i.item}`}>
                <td className="px-2 py-3 font-medium text-slate-900">{i.item}</td>
                <td className="px-2 text-right font-semibold">{i.negative}</td>
                <td className="px-2 text-right text-slate-600">{i.orders}</td>
                <td className={`px-2 text-right font-semibold ${i.negative_pct >= 30 ? "text-red-600" : "text-slate-700"}`}>{i.negative_pct}%</td>
                <td className="px-2 text-slate-600">{i.top_issue}</td>
                {compare && <td className="px-2 text-right text-slate-500">{i.prev_negative}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </Card>
);
